import { render, staticRenderFns } from "./abilityDetectnOrderList.vue?vue&type=template&id=4788136e&scoped=true&"
import script from "./abilityDetectnOrderList.vue?vue&type=script&lang=js&"
export * from "./abilityDetectnOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788136e",
  null
  
)

export default component.exports